import { Link, useLocation } from 'react-router-dom';
import { Home, MessageCircle, Plus, Search, User } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/search', icon: Search, label: 'Search' },
  { to: '/create', icon: Plus, label: 'Create', isCenter: true },
  { to: '/chats', icon: MessageCircle, label: 'Chats' },
  { to: '/profile', icon: User, label: 'Profile' },
];

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bottom-nav-glass border-t border-white/[0.04] safe-area-bottom" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
        {navItems.map(({ to, icon: Icon, label, isCenter }) => {
          const isActive = location.pathname === to || 
            (to === '/' && location.pathname === '/') ||
            (to === '/chats' && location.pathname.startsWith('/chat'));

          if (isCenter) {
            return (
              <Link
                key={to}
                to={to}
                className="flex items-center justify-center w-12 h-12 -mt-4 rounded-2xl bg-gradient-to-br from-[#E11D48] to-[#9333EA] shadow-lg shadow-[#E11D48]/25 transition-all active:scale-90 hover:shadow-xl hover:shadow-[#E11D48]/30"
                data-testid={`nav-${label.toLowerCase()}`}
              >
                <Icon className="w-6 h-6 text-white" />
              </Link>
            );
          }

          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center gap-0.5 py-2 px-3 rounded-xl transition-colors ${
                isActive ? 'text-[#E11D48]' : 'text-[#555] hover:text-[#A1A1AA]'
              }`}
              data-testid={`nav-${label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.5} />
              <span className="text-[10px] font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
